'use strict';

exports.__esModule = true;
exports['default'] = renderNothing;

var _validators = require('../../utils/validators');

function renderNothing(target) {
  (0, _validators.validateClass)(target, 'renderNothing');

  // eslint-disable-next-line
  target.prototype.render = function () {
    return null;
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/components/renderNothing.js
// module id = 558
// module chunks = 1